

















































































import { Component } from "vue-property-decorator";
import { BaseOperationPropertyVue } from "fs-pb-vue2/vueModels/operations/properies/BaseOperationPropertyVue";
import { ContractsStore } from "fs-pb-vue2/store/modules/contracts";
import { getModule } from "vuex-module-decorators";
import { ContractModel } from "fs-pb-vue2/models/contracts/contractModel";

@Component({})
export default class ListProperty extends BaseOperationPropertyVue {
  accountToClose: string = '';
  operationType: string = '';

  mounted() {
    this.accountToClose = this.$route.query.contract as string;
    this.operationType = this.$route.query.operationType as string;
  }

  get filteredItems() {
    if (this.property.Declaration.Name === 'contractTo' && this.operationType === 'closeAccount') {
      return this.property.Values.filter(item => item.Key !== this.accountToClose);
    }
    return this.property.Values;
  }

  get contractsStore(): ContractsStore {
    return getModule(ContractsStore, this.$store);
  }

  getContract(refId: string): ContractModel {
    return this.contractsStore.contracts.getContractByRefId(refId);
  }

  getContractSum(c: ContractModel): string {
    return `${c.Data.ContractType === 5 ? c.Rest : c.DisposableLimit} ${c.Currency}`;
  }
}
